import * as React from 'react';
import { Button } from '../static/Elements';
import Moment from 'moment';

import createLogger from '../../utils/createLogger';
const DEBUG = false;
const debug = createLogger(DEBUG, `OpenWebDetails.js`);

class OpenWebDetails extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showCompanyList: false,
      showDetails: true,
    }
  }

  formatDate = date => {
    return Moment(date).format('MMMM Do YYYY, h:mm:ss a')
  };

  onClickShowDetails = () => {
    this.setState({
      showDetails: true,
      showCompanyList: false,
    })
  };

  onClickShowCompanyList = () => {
    this.setState({
      showCompanyList: true,
      showDetails: false,
    })
  };

  render () {

    const {
      _id,
      _updated,
      start,
      finished,
      name,
      args,
      pid,
      who,
      company_list,
      total_companies_with_jobs,
      total_jobs,
      total_companies_scraped,
      scraped_ids,
      targeted_ids,
    } = this.props.scrape;


    const {
      city,
      radius,
    } = args;

    const {
      showCompanyList,
      showDetails,
    } = this.state;

    const {
      onClickShowDetails,
      onClickShowCompanyList,
      formatDate,
    } = this;

    return (
      <div>
        <div className={`details-selector`}>
          {
            showDetails ? (
              <div className={`details-selected`}>
                <p>Details</p>
              </div>
            ) : (
              <Button onClick={onClickShowDetails}
                      text
                      lowkey>
                Details
              </Button>

            )
          }
          {
            showCompanyList ? (
              <div className={`details-selected`}>
                <p>Company List</p>
              </div>
            ) : (
              <Button onClick={onClickShowCompanyList}
                      text
                      lowkey>
                Company List
              </Button>
            )
          }
        </div>
        <div className={`table-scroll-container`}>
          <table className={`table table-light table-striped table-bordered`}>
            {
              showDetails ? (
                <tbody>
                  <tr>
                    <th>Type</th>
                    <td>{name}</td>
                  </tr>
                  {
                    city ? (
                      <React.Fragment>
                        <tr>
                          <th>City</th>
                          <td>{city}</td>
                        </tr>
                        <tr>
                          <th>Radius</th>
                          <td>{radius}</td>
                        </tr>
                      </React.Fragment>
                    ) : null
                  }
                  <tr>
                    <th>Status</th>
                    {
                      finished === null && targeted_ids !== undefined && scraped_ids !== undefined ? (
                        <td>In Progress ({scraped_ids.length}/{targeted_ids.length})</td>
                      ) : (
                        <td>Finished</td>
                      )
                    }
                  </tr>
                  <tr>
                    <th>Scrape ID</th>
                    <td>{_id}</td>
                  </tr>
                  <tr>
                    <th>Process ID</th>
                    <td>{pid}</td>
                  </tr>
                  <tr>
                    <th>User</th>
                    <td>{who}</td>
                  </tr>
                  <tr>
                    <th>Started</th>
                    <td>{formatDate(start)}</td>
                  </tr>
                  <tr>
                    <th>Updated</th>
                    <td>{formatDate(_updated)}</td>
                  </tr>
                  {
                    finished ? (
                      <tr>
                        <th>Finished</th>
                        <td>
                          {
                            formatDate(finished)
                          }
                        </td>
                      </tr>
                    ) : null
                  }
                  <tr>
                    <th>Total Jobs</th>
                    <td>{total_jobs}</td>
                  </tr>
                  <tr>
                    <th>Companies Scraped</th>
                    <td>{total_companies_scraped}</td>
                  </tr>
                  <tr>
                    <th>Companies with Jobs</th>
                    <td>{total_companies_with_jobs}</td>
                  </tr>
                </tbody>
              ) : showCompanyList ? (
                <tbody>
                <tr>
                  <th>Company</th>
                  <th>ID</th>
                  <th>URL</th>
                  <th>Count</th>
                </tr>
                {
                  company_list.map((co) => (
                      <tr key={co.companyid}>
                        <td>{co.companyname}</td>
                        <td>{co.companyid}</td>
                        <td>{co.companyurl}</td>
                        <td>{co.count}</td>
                      </tr>
                  ))
                }
                </tbody>
              ) : null
            }
          </table>
       </div>
      </div>
    )
  }

}

export default OpenWebDetails;



// WEBPACK FOOTER //
// ./src/components/OpenWeb/OpenWebDetails.js